import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as searchActions from '~/search2/actions';
import CSFilterItem from '~/search2/containers/CSFilterItem';
import CSSeverityFilter from '~/search2/containers/CSSeverityFilter';
import CSDateFilter from '~/search2/containers/CSDateFilter';
import CVSSDropdown from '~/search2/containers/CVSSDropdown';
import {
  ALLOW_COCOAPODS_SEARCH,
  GLOSSARY,
  ALLOW_GO_SEARCH_EXPLORE,
  ALLOW_PHP_SEARCH,
  ALLOW_CSHARP_SEARCH,
  ALLOW_OS_SEARCH,
  ALLOW_CPP_SEARCH,
} from '~/constants/ModelConstants';
import CvssService from '~/utils/CvssService';
import Tooltip from '~/components/Tooltip';
const isCvss3Enabled = CvssService.isCvss3Enabled();
type CSFilterNavProps = {
  actions: object;
  searchDataState: object;
};
class CSFilterNav extends React.Component<CSFilterNavProps, {}> {
  updateFilter = (k, v) => {
    this.props.actions.setFilter(k, v);
  };
  render() {
    const { filters } = this.props.searchDataState;
    let refFunc = ref => {
      if (ref) {
        ref.checked = filters && filters[ref.name] && filters[ref.name].indexOf(ref.value) !== -1;
      }
    };
    return (
      <div id="search-left-nav">
        <div className="col-1-1">
          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="type"
                value="library"
                title="Library"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="type"
                value="vulnerability"
                title="Vulnerability"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>
        </div>

        <div className="col-1-1">
          <div className="font--h6 mb-">
            <i className="sci sci--fw sci__language" /> Language/OS
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="language"
                value="java"
                title="Java"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="language"
                value="ruby"
                title="Ruby"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="language"
                value="javascript"
                title="JavaScript"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="language"
                value="python"
                title="Python"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div
            className={
              'grid grid--full grid--space-between grid--middle mb-- push--col-1-6 ' +
              (ALLOW_COCOAPODS_SEARCH ? '' : 'is-hiding')
            }
          >
            <div className="grid__item">
              <CSFilterItem
                name="language"
                value="objectivec"
                title="Objective-C"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div
            className={
              'grid grid--full grid--space-between grid--middle mb-- push--col-1-6 ' +
              (ALLOW_COCOAPODS_SEARCH ? '' : 'is-hiding')
            }
          >
            <div className="grid__item">
              <CSFilterItem
                name="language"
                value="swift"
                title="Swift"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div
            className={
              'grid grid--full grid--space-between grid--middle mb-- push--col-1-6 ' +
              (ALLOW_GO_SEARCH_EXPLORE ? '' : 'is-hiding')
            }
          >
            <div className="grid__item">
              <CSFilterItem
                name="language"
                value="go"
                title="GO"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div
            className={
              'grid grid--full grid--space-between grid--middle mb-- push--col-1-6 ' +
              (ALLOW_PHP_SEARCH ? '' : 'is-hiding')
            }
          >
            <div className="grid__item">
              <CSFilterItem
                name="language"
                value="php"
                title="PHP"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div
            className={
              'grid grid--full grid--space-between grid--middle mb-- push--col-1-6 ' +
              (ALLOW_CPP_SEARCH ? '' : 'is-hiding')
            }
          >
            <div className="grid__item">
              <CSFilterItem
                name="language"
                value="cpp"
                title="C/C++"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div
            className={
              'grid grid--full grid--space-between grid--middle mb-- push--col-1-6 ' +
              (ALLOW_CSHARP_SEARCH ? '' : 'is-hiding')
            }
          >
            <div className="grid__item">
              <CSFilterItem
                name="language"
                value="csharp"
                title="C#"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div
            className={
              'grid grid--full grid--space-between grid--middle mb-- push--col-1-6 ' +
              (ALLOW_OS_SEARCH ? '' : 'is-hiding')
            }
          >
            <div className="grid__item">
              <CSFilterItem
                name="language"
                value="os"
                title="OS"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>
        </div>

        <div className="col-1-1">
          <div className="font--h6 mb-">
            <i className="sci sci--fw sci__language" />
            Release Date
          </div>
          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSDateFilter name="released" type="all" />
            </div>
          </div>
        </div>

        <div className="col-1-1">
          <div className="font--h6 mb-">
            <i className="sci sci--fw sci__catalog" /> Libraries
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="source"
                value="Maven"
                title="Maven/Gradle"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="source"
                value="PyPI"
                title="PyPI"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="source"
                value="Gem"
                title="Gems"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="source"
                value="npm"
                title="npm"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="source"
                value="Bower"
                title="Bower"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div
            className={
              'grid grid--full grid--space-between grid--middle mb-- push--col-1-6 ' +
              (ALLOW_COCOAPODS_SEARCH ? '' : 'is-hiding')
            }
          >
            <div className="grid__item">
              <CSFilterItem
                name="source"
                value="CocoaPods"
                title="CocoaPods"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div
            className={
              'grid grid--full grid--space-between grid--middle mb-- push--col-1-6 ' +
              (ALLOW_PHP_SEARCH ? '' : 'is-hiding')
            }
          >
            <div className="grid__item">
              <CSFilterItem
                name="source"
                value="Packagist"
                title="Packagist"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div
            className={
              'grid grid--full grid--space-between grid--middle mb-- push--col-1-6 ' +
              (ALLOW_CSHARP_SEARCH ? '' : 'is-hiding')
            }
          >
            <div className="grid__item">
              <CSFilterItem
                name="source"
                value="NuGet"
                title="NuGet"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div
            className={
              'grid grid--full grid--space-between grid--middle mb-- push--col-1-6 ' +
              (ALLOW_OS_SEARCH ? '' : 'is-hiding')
            }
          >
            <div className="grid__item">
              <CSFilterItem
                name="source"
                value="RPM"
                title="RPM"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div
            className={
              'grid grid--full grid--space-between grid--middle mb-- push--col-1-6 ' +
              (ALLOW_OS_SEARCH ? '' : 'is-hiding')
            }
          >
            <div className="grid__item">
              <CSFilterItem
                name="source"
                value="native"
                title="Native"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="text--bold mb-- push--col-1-7 pt--">Licenses</div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="license"
                value="apache"
                title="Apache"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="license"
                value="mit"
                title="MIT"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="license"
                value="bsd"
                title="BSD"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="license"
                value="gpl"
                title="GPL"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="text--bold mb-- push--col-1-7 mr++">
            <hr />
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="vulnerable"
                value="true"
                title="Vulnerable only"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>
        </div>

        <div className="col-1-1">
          <div className="font--h6 mb-">
            <i className="sci sci--fw sci__vulnerability" /> Vulnerabilities
          </div>

          <div className="push--col-1-7 mb--">
            <div className="flex flex--flex-direction--row flex--align-content--stretch flex--align-items--center">
              <div className="flex text--bold">Risk Score</div>
              {isCvss3Enabled && (
                <div className="flex-2 pr mr ml-">
                  <CVSSDropdown />
                </div>
              )}
            </div>
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <CSSeverityFilter />
          </div>

          <div className="text--bold mb-- push--col-1-7 mr++">
            <hr />
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <CSFilterItem
                name="vulnerable_method"
                value="true"
                title="Vulnerable Methods"
                refFunc={refFunc}
                filters={filters}
              />
            </div>
          </div>

          <div className="grid grid--full grid--space-between grid--middle mb-- push--col-1-6">
            <div className="grid__item">
              <Tooltip
                id={`sidebarnav-enhanced-filter-search2`}
                width={`width--200`}
                content={GLOSSARY.ENHANCED}
              >
                <CSFilterItem
                  name="enhanced"
                  value="true"
                  title="Enhanced"
                  refFunc={refFunc}
                  filters={filters}
                />{' '}
                <i className="fa fa-info-circle" />
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    searchDataState: state.searchDataState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(searchActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CSFilterNav);
